import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import BaseDetails from 'containers/Base/BaseDetails.js';
import {
  closeDetails,
  getCurrentPage,
  openDetails,
  toggleModal,
} from 'reducers/ui';
import staticText from 'static/text_display.json';
import { translatedKeyValueText } from 'utils/methods/helpers';
import PropTypes from 'prop-types';
import { getCustomerDetailsTransformed } from '../Selectors/customerSelector';
import { actions as customerActions } from '../Modules/dataGridTable';
import { nameSpace } from '../Modules/nameSpace';

const CustomerDetails = ({ id, editable, toggleEditMode, cancel, loading }) => {
  //------------------------------Selectors---------------------------------
  const details = useSelector(state => getCustomerDetailsTransformed(state));
  const pageUrl = useSelector(state => getCurrentPage(state));
  //-----------------------Actions------------------------------------------
  const dispatch = useDispatch();
  const dispatchFetchCustomerDetails = useCallback(
    id => dispatch(customerActions.fetchGridRowDetails({ id })),
    [dispatch],
  );
  const dispatchOpenDetails = useCallback(url => dispatch(openDetails(url)), [
    dispatch,
  ]);
  // const dispatchClearCustomerDetails = useCallback(
  //   () => dispatch(customerActions.setGridRowDetails({})),
  //   [dispatch],
  // );
  const dispatchCloseCustomerDetailsPanel = useCallback(
    () => dispatch(closeDetails(pageUrl)),
    [dispatch, pageUrl],
  );
  const dispatchSetCustomerID = useCallback(
    id => {
      dispatch(customerActions.setSelectedRowID(id));
    },
    [dispatch],
  );
  const dispatchToggleModal = useCallback(
    nameSpace => dispatch(toggleModal(nameSpace)),
    [dispatch],
  );
  //------------------------------------------------------------------------
  useEffect(() => {
    if (id) {
      dispatchFetchCustomerDetails(id);
      dispatchOpenDetails(pageUrl);
      dispatchSetCustomerID(id);
    }

    // return () => {
    // dispatchClearCustomerDetails();
    // };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);
  const onEdit = () => {
    toggleEditMode();
    dispatchToggleModal(nameSpace);
  };
  const cancelDetails = () => {
    cancel();
    dispatchCloseCustomerDetailsPanel();
  };
  return (
    <BaseDetails
      header={staticText.managerial_view.customer.details}
      cancel={cancelDetails}
      editable={editable}
      onEdit={onEdit}
      details={details}
      loading={loading}
      editHoverText={
        Object.keys(details).length > 0
          ? translatedKeyValueText('edit_value_title', {
              value: details.generalInfo.customerId.value,
            })
          : staticText.managerial_view.customer.edit_default
      }
    />
  );
};
CustomerDetails.propTypes = {
  cancel: PropTypes.func.isRequired,
  editable: PropTypes.bool,
  id: PropTypes.string,
  loading: PropTypes.bool,
  toggleEditMode: PropTypes.func,
};

export default CustomerDetails;
